module.exports = __webpack_public_path__ + "static/img/gazetaTopo1.c29f997.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imagens/DOE-AL/gazetaTopo1.png
// module id = cc0X
// module chunks = 1